"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var ui_1 = require("@bodiless/ui");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var OverlayWrapper = lodash_1.flow(fclasses_1.addClasses(['bl-p-20', 'bl-py-10', 'bl-w-full', 'bl-h-full', 'bl-fixed', 'bl-top-0', 'bl-z-max', 'bl-flex', 'bl-flex-col', 'bl-justify-center', 'bl-items-center', 'bl-bg-black-transparent']), fclasses_1.addProps({
  id: 'page-overlay'
}))(ui_1.Div);
var PopupWrapper = fclasses_1.addClasses('bl-p-5 bl-rounded bl-bg-black')(ui_1.Div);

var Button = function Button(props) {
  var ButtonWrapper = fclasses_1.addClasses('bl-flex bl-pb-5 bl-justify-end bl-w-full')(ui_1.Div);
  var ButtonEl = fclasses_1.removeClasses('bl-float-right')(ui_1.ComponentFormCloseButton);
  return react_1.default.createElement(ButtonWrapper, null, react_1.default.createElement(ButtonEl, __assign({}, props)));
};

var WrappedSpinner = function WrappedSpinner() {
  var SpinnerWrapper = fclasses_1.addClasses('h-20')(ui_1.Div);
  return react_1.default.createElement(SpinnerWrapper, null, react_1.default.createElement(ui_1.Spinner, {
    color: "bl-bg-white"
  }));
};

var Message = fclasses_1.addClasses(['bl-text-gray-100 bl-text-center bl-text-lg bl-whitespace-pre-line clear-right'])(ui_1.Div);
var ui = {
  OverlayWrapper: OverlayWrapper,
  PopupWrapper: PopupWrapper,
  Button: Button,
  Spinner: WrappedSpinner,
  Message: Message
};

var PageOverlay = function PageOverlay(props) {
  return react_1.default.createElement(core_1.PageOverlay, __assign({
    ui: ui
  }, props));
};

exports.default = PageOverlay;